import { useCompareStore } from "~/store/compare";
import { toast } from "react-hot-toast";
import { getRegionUrlPrefix } from "../helpers/slugHelper";
export function useCompare(listingId?: string) {
  const items = useCompareStore((s) => s.items);
  const toggle = useCompareStore((s) => s.toggle);
  const add = useCompareStore((s) => s.add);
  const remove = useCompareStore((s) => s.remove);
  const clear = useCompareStore((s) => s.clear);
  const max = useCompareStore((s) => s.max);

  const compareCount = items.length;
  const isCompared = !!(listingId && items.includes(listingId));

  const toggleCompare = (event?: React.MouseEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (!listingId) return;

    if (items.length >= max && !items.includes(listingId)) {

      toast(`You can select up to ${max} listings for comparison..\n\n Please review your current selection.`, {
        position: "top-right",
        duration: 5000,
        style: { background: "#E76E50", color: "#fff" },
      });

      setTimeout(() => {
        const region = localStorage.getItem("region-config-storage");
        const parsedRegion = JSON.parse(region || '{}');
        const regionData = parsedRegion.state?.regionConfig?.country;
        window.open(`${getRegionUrlPrefix(regionData)}/compare`, "_blank");
      }, 3000);
      return;
    }

    toggle(listingId);
  };

  return {
    items,
    compareCount,
    isCompared,
    toggleCompare,
    add,
    remove,
    clear,
    max,
  };
}